<template>
<div class='days'>
  <div class="picked-date" v-if="slotConfig">
    <h3>{{getLoacleDate()}}</h3>
    <a class='arrow left' href="javascript:" @click="prewiousDay"><svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" v-bind:class="'unlocked'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M40.934 52.428c-.44.44-1.152.44-1.591 0L19.71 32.796a1.125 1.125 0 010-1.591l19.633-19.633c.439-.44 1.151-.44 1.59 0l1.857 1.856c.44.44.44 1.152 0 1.591L25.85 32l16.94 16.98c.44.44.44 1.153 0 1.592l-1.856 1.856z" fill="#2A313C" fill-rule="evenodd"/></svg></a>
    <a class='arrow right' href="javascript:" @click="nextDay"><svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" v-bind:class="'unlocked'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M21.566 11.572c.44-.44 1.152-.44 1.591 0L42.79 31.205c.44.439.44 1.151 0 1.59L23.157 52.429c-.44.44-1.151.44-1.59 0l-1.857-1.856a1.125 1.125 0 010-1.591L36.65 32 19.71 15.02a1.125 1.125 0 010-1.592l1.856-1.856z" fill="#2A313C" fill-rule="evenodd"/></svg></a>
  </div>

  <div class="day-slots-wrap">
    <div class="day-slots" v-if="selectedDate">
      <div class='spacer'>&nbsp;</div>

      <div class="day-details" v-for="plan in showingDays"
          :class="{'selected': selectedDate.yyyymmdd() == plan.date.yyyymmdd(), 'disabled': plan.slots.length == 0}"
          @click="selectPlan(plan)">
        <div class="day-number">{{plan.date.getDate()}}</div>
        <div class="day-name">{{getDayName(plan.date)}}</div>
        <div class="day-slot-counter">
          <span class='dot' v-for="slot in plan.slots" :class="{'disabled' : slot.remaining < 0 || !slot.stopInFuture}" v-if="slot.enabledFor === undefined || slot.enabledFor.includes(methodCode)"></span>
        </div>
        <div class="day-not-filled" v-show="plan.newDay">&nbsp;</div>
      </div>

      <div class="day-details last">
        <span>dál to<br>nejde</span>
      </div>
      <div class='spacer'>&nbsp;</div>
    </div>
  </div>
</div>
</template>

<script>
import {
  db
} from '@/globals'

import Langs from '@/langs'
import Cart from '@/cart'
import Notification from '@/notification'
import Utils from '@/utils'

export default {
  props: ['methodCode'],
  components: {},
  data() {
    return {
      deliveryPlan: null,
      dayNames: Langs.get('dayNames'),
      dayNamesShort: Langs.get('dayNamesShort'),

      products: Cart.data.products,

      firstDate: (new Date()).addDays(-1),
      lastDate: null,
      selectedDate: null,
      showingDays: [],

      openSlotsUnsubscribe: null,

      slotConfig: Cart.shopData.slotConfig,
      range: {
        from: '',
        to: ''
      },

      preselectedSlotMark: null,
    }
  },
  watch: {
    products: {
      deep: true,
      handler() {
        console.log('Products updated, update the slot availability')
        this.loadSlotsUssage(false)
      }
    }
  },
  created() {
    console.log('DayPickerPanel.created')
    this.firstDate = new Date()
    this.firstDate.setHours(0)
    this.firstDate.setMinutes(0)
    this.firstDate.setSeconds(0)
    this.firstDate.setMilliseconds(0)
    this.selectedDate = this.firstDate.addDays(1)

    // is already selected some slot in the cart
    if (Cart.data.delivery.slot && Cart.data.delivery.slot.mark) {
      console.log('Cart contains selected slot, we shall select it, if still available', Cart.data.delivery.slot.mark)
      this.preselectedSlotMark = Cart.data.delivery.slot.mark

      // Get the date
      this.selectedDate.setFullYear(this.preselectedSlotMark.substring(0,4))
      this.selectedDate.setMonth((this.preselectedSlotMark.substring(4,6) * 1) - 1)
      this.selectedDate.setDate(this.preselectedSlotMark.substring(6,8))
      console.log('Selected day for slot selection', this.selectedDate)
    }

    this.getDeliveryPlan()

    this.$parent.$on('updated', () => {
      console.log('Updating selected day')
      // this.getDeliveryPlan()
    })
  },
  beforeDestroy() {
    if (this.openSlotsUnsubscribe) {
      this.openSlotsUnsubscribe()
    }
  },
  methods: {
    getLoacleDate() {
      return this.dayNames[this.selectedDate.getDay()] + ' ' +
        this.selectedDate.getDate() + '.' +
        (this.selectedDate.getMonth() + 1) + '.' +
        this.selectedDate.getFullYear()
    },
    getDayName(date) {
      return this.dayNames[date.getDay()]
    },
    getDayNameShort(date) {
      return this.dayNamesShort[date.getDay()]
    },
    prewiousDay() {
      if (this.selectedDate.yyyymmdd() > this.firstDate.yyyymmdd()) {
        // search for next day with awailable slots.
        console.log('Available plan', this.deliveryPlan)
        let days = Object.keys(this.deliveryPlan)
        let index = days.indexOf(this.selectedDate.yyyymmdd())
        if (index > 0) {
          // Has the day available slots?
          let slots = this.deliveryPlan[days[index - 1]].slots.filter(s => s.remaining >= 0 && s.stopInFuture)
          if (slots.length > 0) {
            this.selectedDate = this.deliveryPlan[days[index - 1]].date
          }
        }
        // this.selectedDate = this.selectedDate.addDays(-1)
        this.moveToDate()
      }
    },
    nextDay() {
      if (this.selectedDate.yyyymmdd() < this.lastDate.yyyymmdd()) {
        // search for next day with awailable slots.
        console.log('Available plan', this.deliveryPlan)
        let days = Object.keys(this.deliveryPlan)
        let index = days.indexOf(this.selectedDate.yyyymmdd())
        if (index < days.length - 1) {
          // Has the day available slots?
          let slots = this.deliveryPlan[days[index + 1]].slots.filter(s => s.remaining >= 0 && s.stopInFuture)
          if (slots.length > 0) {
            this.selectedDate = this.deliveryPlan[days[index + 1]].date
          }
        }
        // this.selectedDate = this.selectedDate.addDays(1)
        this.moveToDate()
      }
    },
    moveToDate() {
      let dayPlan = this.showingDays.find(d => d.date.yyyymmdd() == this.selectedDate.yyyymmdd())
      if (dayPlan) {
        this.selectPlan(dayPlan)
      }
    },
    getDeliveryPlan() {
      this.range = {
        from: this.firstDate,
        to: Cart.shopData.slotConfig.showNextDayCount > -1
              ? this.firstDate.addDays(Cart.shopData.slotConfig.showNextDayCount)
              : '' // Will be filled after last slot is loaded
      }

      let result = {}
      // console.log('Loading delivery planning for shop', this.range, Cart.shopId, JSON.stringify(Cart.shopData.slotConfig))

      let deliverySlotsDocs = db.collection(`shops/${Cart.shopId}/deliverySlots`)
        .where("dateFrom", ">=", this.range.from)
        .where('metadata.deleted', '==', false)
        .orderBy("dateFrom")

      return deliverySlotsDocs.get()
        .then(deliverySlots => {
          console.log('Delivery plan loaded', deliverySlots.docs.length, deliverySlots.size)
          if (deliverySlots.docs.length > 0) {
            for (let i = 0; i < deliverySlots.docs.length; i++) {
              let doc = deliverySlots.docs[i]
              let slot = doc.data()
              // console.log('> evaluating slot', JSON.stringify(slot))
              slot.id = doc.id
              let slotEndDate = (new Date(slot.dateTo.seconds * 1000))
              let thisDate = (new Date(slot.dateFrom.seconds * 1000))
              let dateMark = thisDate.yyyymmdd()

              if (this.range.to != '' && this.range.to < slot.dateTo) {
                // End when loaded the maximum (if specified)
                break
              }
              if (result[dateMark] === undefined) {
                thisDate.setHours(0)
                thisDate.setMinutes(0)
                thisDate.setSeconds(0)

                result[dateMark] = {
                  date: thisDate,
                  slots: []
                }
              }

              if (this.range.to == '' && i == deliverySlots.docs.length - 1) {
                // This should be the last Slot
                // Set the maximal loaded date to the this.range
                this.range.to = result[dateMark].date
              }

              // Fill close time
              if (slot.minutesBefore === undefined) {
                // If no time set, wi will consieder it was meant to be able one day ahead.
                var validUntil = slotEndDate.addMinutes( -1 * 60 * 24)
              } else if (slot.minutesBefore > 0) {
                var validUntil = slotEndDate.addMinutes( -1 * slot.minutesBefore)
              } else {
                var validUntil = slotEndDate
              }
              slot.validUntil = validUntil
              slot.stopInFuture = validUntil > new Date()

              // console.log('Slot added to plan', dateMark, slot)
              result[dateMark].slots.push(slot)

              slot.selected = false
              if (slot.remaining == undefined) {
                slot.remaining = 1 // initial value
              }

              // result[doc.id].slots.sort((a,b)=>{
              //   return a.dateFrom != b.dateFrom
              //         ? (a.dateFrom.getTime() - b.dateFrom.getTime())
              //         : (b.dateTo.getTime() - a.dateTo.getTime())
              // })
            }
            // console.log('Delivery plan with slots', result)
          }
          this.deliveryPlan = result
          // return this.fillDaysToShow()
          return this.loadSlotsUssage(true)
        })
        .catch(e => {
          console.error(e)
        })
    },
    loadSlotsUssage(refreshDaysToShow) {
      // get the actual requested order size
      let orderSize = Cart.getOrderSize()
      console.log(`Order size for slot availability`, orderSize)

      // console.log('Reading used slots for time period', range)
      if (this.openSlotsUnsubscribe != null) {
        this.openSlotsUnsubscribe()
      }
      let occupancy = {}
      let todayMark = (new Date()).yyyymmdd() + '00000000'
      let tomorrow = (new Date()).addDays(1)
      this.openSlotsUnsubscribe = db.collection(`shops/${Cart.shopId}/deliverySlots`)
        .where("mark", ">=", todayMark)
        .where("mark", "<=", this.range.to.addDays(1).yyyymmdd() + '00000000')
        .onSnapshot((querySnapshot) => {
          console.log(`Some slots were updated while processing state is ${Cart.data.processingState}`, this.deliveryPlan)
          if (['working', 'success'].includes(Cart.data.processingState)) {
            console.log('Ignoring the change now.')
            return
          }
          // Get and count the slot ussage
          querySnapshot.forEach((doc) => {
            let slot = doc.data()
            let slotUssage
            if (occupancy[slot.mark]) {
              // The slot is already in the overview
              slotUssage = occupancy[slot.mark]
            } else {
              // The slot is new
              slotUssage = {
                used: orderSize // The used minimum is the size of current order
              }
              occupancy[slot.mark] = slotUssage
            }

            if (slot.used === undefined || slot.used == null) {
              // If the slot is not used at all, skip the rest
              // console.log('The slot is not used at all', slot)
              return
            }
            // console.log('Actual slot.', slot, slot.used.length)
            slot.used.forEach(order => {
              console.log(`Adding to slot ussage ${slotUssage.used} with size ${order.size}`, order)
              slotUssage.used = slotUssage.used + isNaN(order.size) ? 0 : order.size
            })
          })
          // Mark used slots
          let planDays = Object.keys(this.deliveryPlan)
          planDays.forEach(plan => {
            console.log('Checking the plan', tomorrow, plan)
            let allSlotsDisable = false

            // If the time today is past the closing time, all slots will be disabled
            if (tomorrow.yyyymmdd() == plan) {
              console.log('Ordering for tomorrow')
              // Get closing time
              let hm = Utils.getPlanCloseTime(this.deliveryPlan[plan], Cart.shopData)
              if (hm.length == 2) {
                // Is it ower
                let closingTime = new Date()
                closingTime.setHours(hm[0])
                closingTime.setMinutes(hm[1])
                closingTime.setSeconds(0)

                if (closingTime < (new Date())) {
                  allSlotsDisable = true
                }
              }
            } else {
              console.log('Ordering for other day than tomorrow')
            }

            this.deliveryPlan[plan].slots.forEach(s => {
              if (occupancy[s.mark]) {
                if (allSlotsDisable) {
                  s.remaining = -1
                } else {
                  let slotLength = (s.dateTo.seconds - s.dateFrom.seconds) / 60 // in minutes
                  let slotCapacity = slotLength * s.staff
                  console.log(`>Slot ${s.mark} with length ${slotLength}s, staff of ${s.staff} has capacity: ${slotCapacity}`)

                  // The slot is occupied. The amount is in minutes
                  // The slot staff is in ManHours
                  let remainingStaf = slotCapacity - occupancy[s.mark].used
                  console.log((remainingStaf < 0) ? 'Slot will be disabled' : 'Slot is available', `, Slot capacity: ${s.staff * 60}`)
                  s.remaining = remainingStaf

                  // s.available = s.staff * 60
                  if (this.preselectedSlotMark == s.mark) {
                    console.log('The slot was selected before... can we still use it?', remainingStaf >= 0)
                    // We should marh this slot as selected... or deletect it, if no longer available
                    if (remainingStaf < 0) {
                      // Slot no longer available
                      delete Cart.data.delivery['slot']
                      Vue.set(Cart.data.delivery, 'slot', null)
                    } else {
                      s.selected = true
                    }
                  }

                  console.log('Is slot preselected?', s.selected, (this.preselectedSlotMark == s.mark))
                }

              }

              // Check if the customer didn't already select this slot and if is still available
              if (Cart.data.delivery.slot && Cart.data.delivery.slot.id == s.id) {
                console.log('Updated slot, that user has selected')
                if (s.remaining < 0) {
                  s.selected = false
                  delete Cart.data.delivery['slot']
                  Vue.set(Cart.data.delivery, 'slot', null)
                  Notification.add('err', Langs.get('delivery-slot-no-longer-available'))
                }
              }
            })
          })
          // console.log("Currently used slots: ", occupancy)
          console.log('Delivery plan with slots', this.deliveryPlan)

          if (refreshDaysToShow) {
            this.fillDaysToShow()
          }
        })
    },

    fillDaysToShow() {
      console.log('fillDaysToShow()')
      this.showingDays.splice(0)
      let today = new Date()
      let printed = []
      let daysToPrint = Object.keys(this.deliveryPlan)

      let daysPlus = 0
      let d
      let selectedFirstPlan = false
      while (printed.length < daysToPrint.length) {
        d = this.firstDate.addDays(daysPlus)
        // Get slots defined for this date
        let plan = this.deliveryPlan[d.yyyymmdd()]
        if (plan != undefined) {
          this.showingDays.push(plan)
          // if (plan.date < today) {
          //   plan.slots.splice(0)
          // }

          // if there is a selected slot alredy
          if (this.preselectedSlotMark != null && !selectedFirstPlan) {
            if (this.selectedDate.getTime() == plan.date.getTime()) {
              console.log('Selecting preselected day with plan', plan)
              selectedFirstPlan = true
              this.$emit('plan-picked', {plan: plan, initial: true})
            }
          } else
          // Select first plan with some slots
          if (plan.slots.length > 0 && !selectedFirstPlan) {
            // console.log('Selecting first day with plan', plan)
            selectedFirstPlan = true
            this.selectedDate = plan.date
            this.$emit('plan-picked', {plan: plan, initial: true})
          }

          printed.push(d.yyyymmdd())
        } else {
          // This means the day has no slots for delivery.
          this.showingDays.push({
            date: d,
            slots: []
          })
        }

        daysPlus++
      }
      this.lastDate = d
    },
    selectPlan(plan) {
      console.log('clicked select day', plan)
      Utils.scrollTo({
        targetElementId: 'shipping-module'
      })
      if (plan.slots.length > 0) {
        let isAnyAvailable = plan.slots.filter(s => s.remaining >= 0 && s.stopInFuture)
        if (isAnyAvailable.length == 0) {
          console.log('No slot available')
          return
        }
        // Remove previously selected slot
        delete Cart.data.delivery['slot']
        Vue.set(Cart.data.delivery, 'slot', null)

        this.selectedDate = plan.date
        this.$emit('plan-picked', {plan: plan, initial: false})
      }
    },
    getSlotTime(slot) {
      if (slot) {
        return this.getTimeHHMM(slot.from) + this.getTimeHHMM(slot.to)
      }
      return '00000000'
    },
    getTimeHHMM(time) {
      if (time) {
        return time.replace(/\,/g, '')
      }
      return '0000'
    },
  }
}
</script>

<style lang='less' scoped>
@import '../../../../variables.less';

.days {
  padding-top: 30px;

    .picked-date {
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;

        h3 {
            flex: 1;
        }

        .arrow {
            padding: 15px;

            &.right {
                padding-right: 0;
            }

            svg {
                width: 28px;
                height: 28px;
            }
        }
    }

    .day-slots-wrap {
        width: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        pointer-events: auto;
        scrollbar-width: none;
        position: absolute;
        left: 0;
        right: 0;

        &::-webkit-scrollbar {
            width: 0;
            background: transparent;
        }

        .day-slots {
            display: flex;
            flex-direction: row;

            .day-details {
                padding: 16px 0 10px;
                min-width: 70px;
                border-radius: 7px;
                background-color: @pfm-cart-color-form-switch-bg;
                margin: 0 4px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;

                &:hover {
                    background-color: @pfm-cart-color-form-switch-bg-hover;
                }

                &.selected {
                    background-color: @pfm-cart-color-form-switch-bg-selected;

                    .day-number {
                      color: @pfm-cart-color-form-switch-text-selected;
                    }

                    .day-slot-counter {
                      span.dot {
                        &.disabled {
                          background-color: @pfm-color-neutral-600;
                        }
                      }
                    }
                }

                &.disabled {
                  background-color: @pfm-cart-color-form-switch-background-disabled;

                  .day-number {
                    color: @pfm-cart-color-form-switch-text-disabled;
                  }

                  .day-name {
                    color: @pfm-cart-color-form-switch-text-disabled;
                  }
                }

                &.last {
                  text-align: center;
                  justify-content: center;
                  padding: 0;

                  span {
                    color: @pfm-cart-color-form-switch-text-secondary;
                  }
                }

                .day-number {
                    font-size: 1.25rem;
                    color: @pfm-cart-color-form-switch-text;
                    font-weight: 500;
                }

                .day-name {
                    font-size: 0.9375rem;
                    color: @pfm-cart-color-form-switch-text-secondary;
                    letter-spacing: 0;
                }

                .day-slot-counter {
                    display: flex;
                    flex-direction: row;
                    padding-top: 4px;
                    min-height: 10px;

                    span.dot {
                        margin: 0 1px;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        display: block;
                        background-color: @pfm-cart-color-form-switch-dot;

                        &.disabled {
                          background-color: @pfm-cart-color-form-switch-dot-disabled;
                        }
                    }
                }

                .day-not-filled {}
            }

            .spacer {
              width: 10px;
              display: block;
            }
        }
    }
}
</style>
